import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EcgViewerComponent } from './ecg-viewer.component';

const routes: Routes = [
  {
    path: 'ecg-details/:ecgId/:nidaId/:timestamp/:protocolId',
    component: EcgViewerComponent,
  },
  {
    path: 'ecg-details/:ecgId/:nidaId/:timestamp',
    component: EcgViewerComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EcgViewerRoutingModule {}
